module.exports = "/_next/static/images/logo_ba_lichtenberg-0fe905707dd59615f32d75c948afdc8a.svg";